import { render, staticRenderFns } from "./AgentProfileAppraisal.vue?vue&type=template&id=dda1dfce&scoped=true&"
import script from "./AgentProfileAppraisal.vue?vue&type=script&lang=ts&"
export * from "./AgentProfileAppraisal.vue?vue&type=script&lang=ts&"
import style0 from "./AgentProfileAppraisal.vue?vue&type=style&index=0&id=dda1dfce&scoped=true&lang=css&"
import style1 from "./AgentProfileAppraisal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda1dfce",
  null
  
)

export default component.exports